const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f41268f47bba18d795a6e53d6b3088a766ca6d90"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["budg@budg"]={id:"f41268f47bba18d795a6e53d6b3088a766ca6d90"};
      